"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchListing = void 0;
const react_1 = __importStar(require("react"));
const SearchListing = ({ title = 'Search results', count, subTitle, showSort = false, defaultSortKey: sort, sortOptions, onSort, children, }) => {
    const handleSelectChange = (0, react_1.useCallback)((event) => {
        const key = event.target.value;
        if (onSort) {
            onSort(key);
        }
    }, [onSort]);
    return (react_1.default.createElement("div", { className: "searchListing" },
        react_1.default.createElement("div", { className: "searchListing__header" },
            react_1.default.createElement("div", { className: "searchListing__title-group" },
                react_1.default.createElement("div", { className: "searchListing__title" },
                    title,
                    count && react_1.default.createElement("span", null,
                        "\u00A0(",
                        count,
                        ")")),
                subTitle && react_1.default.createElement("div", { className: "searchListing__sub-title" }, subTitle)),
            showSort && sortOptions && onSort && (react_1.default.createElement("div", { className: "searchListing__sorter" },
                react_1.default.createElement("span", { className: "searchListing__sort-label" }, "Sort by"),
                react_1.default.createElement("select", { defaultValue: sort, onChange: handleSelectChange, className: "searchListing__sort-select" }, Object.entries(sortOptions).map(([key, value]) => {
                    return (react_1.default.createElement("option", { key: key, value: key }, value));
                })),
                react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "searchListing__sort-icon" },
                    react_1.default.createElement("path", { d: "M6.529 8.56033L8.4715 10.5028C8.764 10.7953 9.2365 10.7953 9.529 10.5028L11.4715 8.56033C11.944 8.08783 11.6065 7.27783 10.939 7.27783H7.054C6.3865 7.27783 6.0565 8.08783 6.529 8.56033Z", fill: "black" }))))),
        react_1.default.createElement("ol", { "aria-label": `${title} listing sorted by ${sort}`, "aria-live": "polite", className: "searchListing__list" }, children)));
};
exports.SearchListing = SearchListing;
